import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map, Observable } from 'rxjs';
import { SocialInitiative } from 'src/app/components/shared/social-initiative/social-initiative.abstract';
import { Session } from 'src/app/interfaces';
import { ActionBtnInfo } from 'src/app/interfaces/views.interface';
import { InviteCardType } from 'src/app/views/cards/cards.types';
import { ActionsHandlerService } from '../../../actions-handler.service';
import { SearchStrategyTypes } from '../../../search.enum';
import { socialGroupSearchOptions } from '../../../search.options';
import { SearchService } from '../../../search.service';
import { BasicSearchComponent } from '../../basic-search/basic-search.component';
import { SocialGroup, SocialGroupEntity, SocialGroupType } from '../social-group.interface';

@Component({
  selector: 'app-invite-to-social-group-search',
  templateUrl: './invite-to-social-group-search.component.html',
  styleUrls: ['../../shared-search/shared-search.component.scss'],
  providers: [SearchService, ActionsHandlerService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InviteToSocialGroupSearchComponent<T extends SocialGroupEntity> extends BasicSearchComponent {
  @Input({ required: true }) readonly entity: T;

  protected socialGroup: SocialGroup;

  public readonly SEARCH_OPTIONS = socialGroupSearchOptions;

  public readonly CARD_TYPES: Record<SocialGroupType, InviteCardType> = {
    Project: InviteCardType.INVITE_TO_PROJECT,
    Community: InviteCardType.INVITE_TO_COMMUNITY,
  };

  private changeDetector = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);
  private actionsHandler = inject(ActionsHandlerService);
  private socialGroupService = inject(SocialInitiative, { skipSelf: true });

  public get isSocialGroupLeader$(): Observable<boolean> {
    return this.sessionService.sessionChanges.pipe(
      map((session: Session) => session.userId === this.entity.creator.user_id),
    );
  }

  public ngOnInit(): void {
    this.excludeIds = [this.entity.creator.user_id];
    this.searchService.setStrategy(SearchStrategyTypes.INVITE);

    //  TODO use async pipe
    this.socialGroupService.socialGroup$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((socialGroup: SocialGroup) => {
        this.socialGroup = socialGroup;
        this.changeDetector.markForCheck();
      });
  }

  public onAction(actionButton: ActionBtnInfo): void {
    const { entityId, membersIds, type } = this.socialGroup;

    this.actionsHandler.handleAction(
      type,
      entityId,
      actionButton,
      membersIds.pendingJoinRequests.has(actionButton.actionBtnId),
    );
  }
}
